<template>
<ul class="tw-flex tw-items-center">
    <li>
        <button type="button" aria-label="First" @click="page(1)" :disabled="onFirstPage" class="tw-block tw-text-3xl tw-leading-none tw-px-3 tw-text-gray-500 disabled:tw-text-gray-300 tw-no-underline tw-pb-2">
            <span aria-hidden="true">&laquo;</span>
        </button>
    </li>
    <li>
        <button type="button" aria-label="Previous" @click="page(links.current_page - 1)" :disabled="onFirstPage" class="tw-block tw-text-3xl tw-leading-none tw-px-3 tw-text-gray-500 disabled:tw-text-gray-300 tw-no-underline tw-pb-2">
            <span aria-hidden="true">&lsaquo;</span>
        </button>
    </li>

    <li class="tw-flex tw-space-x-2 tw-items-center tw-px-2">
        <input type="number" :min="1" :max="links.last_page" @keydown.enter="page($event.target.value)" class="form-control input-sm" style="width: 50px" :value="links.current_page">
        <p>of {{ links.last_page }}</p>
    </li>

    <li>
        <button type="button" aria-label="Next" @click="page(links.current_page + 1)" :disabled="onLastPage" class="tw-block tw-text-3xl tw-leading-none tw-px-3 tw-text-gray-500 disabled:tw-text-gray-300 tw-no-underline tw-pb-2">
            <span aria-hidden="true">&rsaquo;</span>
        </button>
    </li>
    <li>
        <button type="button" aria-label="Last" @click="page(links.last_page)" :disabled="onLastPage" class="tw-block tw-text-3xl tw-leading-none tw-px-3 tw-text-gray-500 disabled:tw-text-gray-300 tw-no-underline tw-pb-2">
            <span aria-hidden="true">&raquo;</span>
        </button>
    </li>
</ul>
</template>

<script>
export default {
    name: "BasePagination",

    props: {
        links: {
            type: Object,
            required: true
        }
    },

    computed: {
        onFirstPage() {
            return this.links.current_page == 1;
        },

        onLastPage() {
            return this.links.current_page == this.links.last_page;
        }
    },

    methods: {
        page(page) {
            if(page > 0 && page <= this.links.last_page) {
                this.$emit('paged', page);
            }
        }
    }
}
</script>